var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Groupe_5",
    "data-name": "Groupe 5",
    width: 200,
    height: 196,
    viewBox: "0 0 200 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M150.936,64.213l-4.286.715a1.712,1.712,0,1,0,.563,3.377l2.294-.383v52.16l-45.65,7.609a1.712,1.712,0,0,0,.28,3.4,1.756,1.756,0,0,0,.283-.023l47.08-7.847a1.711,1.711,0,0,0,1.43-1.689V65.9a1.711,1.711,0,0,0-1.993-1.689M56.05,60.344a1.707,1.707,0,0,0-.689,1.371v55.537a1.712,1.712,0,0,0,1.22,1.64L66,121.72a1.712,1.712,0,0,0,.984-3.28l-8.2-2.46V64.012L93.859,74.457l.037,52.9-43.67-7.278V67.922l2.293.383a1.712,1.712,0,1,0,.563-3.377L48.8,64.213A1.712,1.712,0,0,0,46.8,65.9v55.63a1.712,1.712,0,0,0,1.43,1.689l47.1,7.849a1.712,1.712,0,0,0,1.994-1.689l-.039-56.2a1.713,1.713,0,0,0-1.223-1.639l-38.5-11.465a1.69,1.69,0,0,0-.486-.07,1.714,1.714,0,0,0-1.025.339M99.855,0a1.719,1.719,0,0,0-.881.25L.835,60.161a1.712,1.712,0,1,0,1.783,2.923L99.867,3.716l96.711,58.868v72.643h-95V75.737l39.37-11.724V115.98l-8.2,2.457a1.712,1.712,0,1,0,.983,3.279l9.416-2.823a1.712,1.712,0,0,0,1.22-1.64V61.716a1.713,1.713,0,0,0-2.2-1.64L99.377,72.82a1.711,1.711,0,0,0-1.223,1.64v62.478a1.711,1.711,0,0,0,1.712,1.711H198.29A1.712,1.712,0,0,0,200,136.938V61.622a1.714,1.714,0,0,0-.822-1.462L100.756.249A1.721,1.721,0,0,0,99.878,0Z",
    transform: "translate(-0.014)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.001,
    y1: 1.411,
    x2: 0.005,
    y2: 1.411,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f39000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b347"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 200,
    height: 196,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 200.229,
    height: 138.65,
    transform: "translate(-0.241 0)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M109.637,43.874c-.425-2.082-1.574-3.362-3.357-3.648a4.753,4.753,0,0,0-.754-.058c-2.77,0-6.23,2.237-7.57,6.309l-.053.143c-.023.057-2.494,6.311.454,10.682,1.6,2.37,4.573,3.855,8.828,4.463-3.853-2.879-5.611-7.335-5.034-10.932.482-3,2.717-6.177,7.487-6.958",
    transform: "translate(-12.641 -5.239)",
    fill: "#60beec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M107.78,52.707c-.459,2.863,1.8,6.859,6.25,8.324l.143.053c.058.024,6.31,2.494,10.681-.454,2.368-1.6,3.852-4.566,4.462-8.814a12.318,12.318,0,0,1-9.547,5.128,8.8,8.8,0,0,1-1.382-.107c-3-.482-6.177-2.717-6.959-7.488-2.081.425-3.362,1.574-3.648,3.357",
    transform: "translate(-14.051 -6.437)",
    fill: "#38a8e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M116.9,46.227c.425,2.082,1.574,3.363,3.357,3.649,2.861.457,6.858-1.8,8.324-6.25l.054-.142c.023-.057,2.493-6.312-.455-10.682-1.6-2.371-4.574-3.857-8.831-4.465,3.848,2.876,5.61,7.326,5.039,10.918-.477,3-2.71,6.19-7.489,6.972",
    transform: "translate(-15.248 -3.696)",
    fill: "#60beec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M117.429,38.717c.464-2.923-1.747-6.832-6.251-8.317l-.143-.052c-.057-.023-6.31-2.493-10.681.455-2.376,1.6-3.875,4.563-4.481,8.835a12.326,12.326,0,0,1,9.567-5.15,8.69,8.69,0,0,1,1.382.109c3.005.482,6.19,2.716,6.968,7.5,2.083-.427,3.356-1.589,3.639-3.376",
    transform: "translate(-12.505 -3.829)",
    fill: "#38a8e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M5.775,210.268A19.428,19.428,0,0,1,0,208.032l3.24-7.33a20.541,20.541,0,0,0,4.771,1.98,18.622,18.622,0,0,0,5.07.748,7.844,7.844,0,0,0,2.983-.406,1.3,1.3,0,0,0,.895-1.214c0-.625-.388-1.094-1.172-1.406a25.137,25.137,0,0,0-3.857-1.023,44.041,44.041,0,0,1-5.75-1.556,9.815,9.815,0,0,1-4.01-2.728,7.407,7.407,0,0,1-1.7-5.135,8.827,8.827,0,0,1,1.578-5.116,10.419,10.419,0,0,1,4.706-3.622,19.612,19.612,0,0,1,7.609-1.32,27.609,27.609,0,0,1,6.031.661,18.857,18.857,0,0,1,5.219,1.938l-3.027,7.287a18.507,18.507,0,0,0-8.31-2.217q-3.875,0-3.877,1.877,0,.895,1.152,1.342a24.371,24.371,0,0,0,3.79.959,38.679,38.679,0,0,1,5.754,1.47,10,10,0,0,1,4.071,2.705,7.256,7.256,0,0,1,1.723,5.114,8.742,8.742,0,0,1-1.575,5.093,10.606,10.606,0,0,1-4.71,3.623A19.278,19.278,0,0,1,13,211.1a31.35,31.35,0,0,1-7.224-.83",
    transform: "translate(0 -23.466)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M59.059,188.186l-9.59,23.779q-1.831,4.56-4.56,6.394a11.727,11.727,0,0,1-6.69,1.832,14.1,14.1,0,0,1-3.943-.576,8.807,8.807,0,0,1-3.131-1.514l3.2-6.6a6.316,6.316,0,0,0,1.641.895,5.064,5.064,0,0,0,1.769.342,2.987,2.987,0,0,0,2.386-.938l-9.8-23.61h9.883l4.817,12.487,4.9-12.487Z",
    transform: "translate(-3.957 -24.546)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M88.2,190.3q2.617,2.6,2.618,7.842v13.3h-9.63V199.8q0-4.006-2.855-4.005a3.342,3.342,0,0,0-2.622,1.129,5.276,5.276,0,0,0-1,3.558v10.952h-9.63V188.122h9.163v2.3a8.93,8.93,0,0,1,3.156-2.047,10.807,10.807,0,0,1,3.877-.681,9.412,9.412,0,0,1,6.926,2.6",
    transform: "translate(-8.489 -24.482)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M119.673,205.321H108.336l-2,5.2H96.107l13.04-29.831h9.884l13.043,29.831h-10.4Zm-2.771-7.245-2.9-7.5-2.9,7.5Z",
    transform: "translate(-12.536 -23.568)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M139.46,183.175a4.664,4.664,0,0,1,0-7.031,6.179,6.179,0,0,1,4.2-1.385,6.352,6.352,0,0,1,4.217,1.321,4.247,4.247,0,0,1,1.577,3.41,4.7,4.7,0,0,1-1.577,3.643,6.045,6.045,0,0,1-4.217,1.429,6.179,6.179,0,0,1-4.2-1.386m-.621,3.261h9.631v23.311h-9.631Z",
    transform: "translate(-17.982 -22.795)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M171.669,187.7v8.523a14.794,14.794,0,0,0-2.13-.17q-4.947,0-4.945,5.029v10.356h-9.631v-23.31h9.163v2.514q2.56-2.941,7.543-2.941",
    transform: "translate(-20.213 -24.482)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 12.783,
    height: 7.243,
    transform: "translate(153.544 171.014)",
    fill: "#0063af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M215.833,194.691h8.737v12.616a20.283,20.283,0,0,1-6.139,2.812,25.292,25.292,0,0,1-6.86.98A18.218,18.218,0,0,1,203,209.117a14.792,14.792,0,0,1-5.944-5.539,16.219,16.219,0,0,1,0-16.153,14.7,14.7,0,0,1,6.01-5.54,18.8,18.8,0,0,1,8.712-1.98,20.015,20.015,0,0,1,7.865,1.469,14.823,14.823,0,0,1,5.775,4.283l-6.437,5.669a8.555,8.555,0,0,0-6.69-3.281,7.056,7.056,0,0,0-5.285,2,7.454,7.454,0,0,0-1.96,5.453,7.54,7.54,0,0,0,1.939,5.414,6.8,6.8,0,0,0,5.177,2.044,9.468,9.468,0,0,0,3.666-.724Z",
    transform: "translate(-25.423 -23.466)",
    fill: "#0063af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2bfd09b89e3dae7bf54711238b41ad18.svg";
export { ForwardRef as ReactComponent };